module.exports = __webpack_public_path__ + "static/meda-provider9-289b60db1b78da4e8a654508a73e4718.png";